import React, { FC } from "react";
import { ModuleConfig } from "@evergis/api";

import { DashboardContainer } from "./DashboardContainer";

import { useProjectDataSources } from "../hooks/useProjectDataSources";
import { useProjectDataSourceFilters } from "../../FeatureCard/hooks/useProjectDataSourceFilters";
import { useReferenceLayerInfos } from "../../FeatureCard/hooks/useReferenceLayerInfos";
import { useDashboardProjectLayers } from "../hooks/useDashboardProjectLayers";
import { useWidgetConfiguration } from "../hooks/useWidgetConfiguration";
import { useDashboardPageOptions } from "../../../hooks/project/useDashboardPageOptions";
import { useInitDashboardLayers } from "../../../hooks/project/useInitDashboardLayers";
import { useDashboardPresentation } from "../hooks/useDashboardPresentation";
import { WidgetType } from "../../FeatureCard/types";

export const Dashboard: FC<ModuleConfig> = () => {
  const [filters] = useProjectDataSourceFilters();
  const { currentConfig } = useWidgetConfiguration(WidgetType.Dashboard);

  useReferenceLayerInfos(currentConfig?.dataSources);
  useProjectDataSources(filters);
  useDashboardProjectLayers();
  useInitDashboardLayers();
  useDashboardPageOptions();
  useDashboardPresentation();

  return <DashboardContainer />;
};
